import React, { Component } from 'react';
import './PageSummary.css';
//import IconApp from './icon-app.js';

class PageSummary extends Component {
  

  render() {
    return (
      <div className="PageSummary">
          <div className="clock-time">9:11</div>
          <div className="clock-date">Sunday, March 15</div>
          <div className="page-summary-block">
            Sunday, March 15
          </div>
      </div>
    );
  }
}

export default PageSummary;
